export default "/_next/static/images/6c97cc4124517ecf5ca547fc79c96c43.jpg";